export type ExternalProvider = 'google' | 'etsy' | 'tiktok';

// Off until TikTok approves our app: hides TikTok sign in and sign up; the backend keeps supporting it
export const TIKTOK_SIGN_IN_ENABLED = false;

export const externalProviderLabels: Record<ExternalProvider, string> = {
    google: 'Google',
    etsy: 'Etsy',
    tiktok: 'TikTok'
};

/** Mirrors ExternalAuthOutcome in Turcos.Business. */
export enum ExternalAuthOutcome {
    SignedIn = 0,
    CheckoutRequired = 1,
    FormPrefilled = 2,
    EmailRequired = 3
}

/** Mirrors ExternalCheckoutStatus in Turcos.Business. */
export enum ExternalCheckoutStatus {
    Pending = 0,
    SignedIn = 1
}

export interface ExternalCheckoutResult {
    status: ExternalCheckoutStatus;
    loginTicket?: string;
}

export interface ExternalAuthResult {
    outcome: ExternalAuthOutcome;
    loginTicket?: string;
    pendingTicket?: string;
    checkoutUrl?: string;
    email?: string;
    name?: string;
    /** Suggested username for a prefilled form, which the user can still change. */
    username?: string;
    storeType?: number;
}

export interface ExternalSignUpData {
    pendingTicket: string;
    storeType?: string;
    storeUrl?: string;
    companyName?: string;
    username?: string;
    email?: string;
}

/** What the popup callback page in the Shopify app posts back to us. */
export interface ExternalAuthMessage {
    action: 'external-auth-completed';
    provider: ExternalProvider;
    code: string;
    state: string;
    error: string;
}
